<template>
	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template> 

<script>
export default {
	name: 'app',
	mounted() {
	},
	methods:{
		
	},
}

</script>
<style>
.mar_right10{
    margin-right: 10px;
}
.mar_btm10{
    margin-bottom: 10px;
}
.mar_all10{
    margin: 10px;
}
.search_right{
    flex:1;
    justify-content: flex-end;
    flex-wrap: wrap;
}
</style>
<style>
body {
	margin: 0px;
	padding: 0px;
    background: #eff0f4;
    /* font-size: 14px; */
    font: 14px/1.5 arial,tahoma,'Hiragino Sans GB','Hiragino Sans GB W3','Microsoft Yahei',\5b8b\4f53;
}
html, body{
    width: 100%;
    height: 100%;
}
a:link { 
	color: #333; 
	text-decoration: none;
}
a:visited { 
  color: #333;
 } 
a:focus { 
	outline: none; 
}
ul li{
	list-style: none;
}
*{
    margin: 0;
    padding: 0;
    outline: 0;
}
label{
    font-weight: 100;
}
img {
     border: 0 none; 
     vertical-align: top; 
}
button{
    cursor: pointer;
    outline:none;
}
input[type="file"] {
  cursor: pointer;
}
input{
    -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
    background: transparent;
    border: 0;
    font-size: 100%;
    margin: 0;
    outline: 0;
    padding: 0;
    vertical-align: baseline;
}
input::placeholder {
    color: #c1c5ce
}
#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}
.Pad0{
    padding: 0 !important;
}
.ColorRed{
    color:#FF0000 !important;
}
.ColorGreen{
    color:#33ae22 !important;
}
.ColorBlue{
    color:#000FFF !important;
}
.ColorGray{
    color:#b3b3b3 !important;
}
.hide{
    display: none !important;
}
.BlockHide{
   	visibility: hidden;
}
.CommTableHei{
    max-height: 20vw;
    overflow-y: auto;
}
.CommTableHei2{
	max-height: 30vw;
	overflow-y: auto;
}
.CommPosFixed{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 999;
}
*::-webkit-scrollbar{
    width:5px;
    height:5px;
}
*::-webkit-scrollbar-track{
    background: #eff1f6;
    border-radius:2px;
}
*::-webkit-scrollbar-thumb{
    background: #c5cdda;
    border-radius:2px;
}
.el-table{
    color: #444549 !important;
}
.el-table thead tr,.el-table thead th{
    /* background: #F0F2F5; */
    padding: 8px 0;
    border-top: 1px solid #e5e9f2;
}
.el-table thead th:not(:first-child){
    border-left: 1px solid #e5e9f2;
}
.el-table td, .el-table th{
    padding: 8px 0;
    /* font-size: 12px; */
}
.el-table th.is-sortable {
    padding: 0;
}
.el-table th.is-sortable .cell{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.el-table.el-table--enable-row-hover .el-table__row{
    cursor: pointer;
}
.el-input-group__append, 
.el-input-group__prepend{
    background: initial;
    padding: 0 15px;
}
.el-pagination{padding: 10px;}
.el-pagination.is-background .btn-next, 
.el-pagination.is-background .btn-prev, 
.el-pagination.is-background .el-pager li{
    min-width: 33px ;
}
.el-pagination.is-background .el-pager li{
    background-color: #fff;
    border: 1px solid #fff;
    line-height: 25px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
    border: 1px solid #409EFF;
    color: #409EFF;
    background: #fff;
}
.el-pagination button, 
.el-pagination span:not([class*=suffix]){
    height: 32px;
    line-height: 29px;
}
.el-pagination__jump{
    margin-left: 0px;
    border-radius: 3px;
    padding: 0 5px;
    border: 1px solid #DCDFE6;
}
.el-pagination__editor.el-input{
    width: 40px;
    padding: 0;
    margin: 0;
    height: initial;
}
.el-pagination__jump .el-pagination__editor.el-input .el-input__inner{
    border: 0;
    height: 20px;
}
.el-pagination .el-select .el-input .el-input__inner{
    height: 32px;
    line-height: 32px;
}
/* .el-table .cell{white-space: nowrap;} */
.el-table th>.cell{padding-left: 14px;}
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar,
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar{width: 10px;height: 10px;}
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track,
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track{background: #eff1f6;}
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb{background-color: #c5cdda;}
/* .el-popover{padding: 0;} */
.el-switch{display: block;margin-bottom: 10px;}
.el-table--scrollable-x .el-table__fixed {height:auto !important;bottom: 10px !important;}
.el-switch__core{width: 25px !important;height: 14px;}
.el-switch__core::after{width: 10px;height: 10px;}
.el-switch.is-checked .el-switch__core::after{margin-left: -10px;}
.el-switch__label *{font-size: 12px;}
.el-button--mini, .el-button--mini.is-round{padding: 7px 12px;}
.el-dialog{background: rgb(255, 255, 255);box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 10px;margin-top: 20vh !important;}
.el-dialog__body{padding: 15px;}
.el-drawer.rtl{outline: 0;}
.el-message-box{width: 50%;}
.el-message-box .el-message-box__content{max-height: 600px;overflow-y: auto;}
.el-loading-spinner {
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);}
</style>